import React from "react";
import Container from "components/atoms/Container";
import Header from "components/uikit/Header/Header";
import Breadcrumbs from "components/molecures/Breadcrumbs";
import { Box } from "@material-ui/core";

export default function NotFoundPage() {
  // const classes = useStyles();

  return (
    <>
      <Header
        color="white"
        brand="Kazi ONLINE"
        fixed
        changeColorOnScroll={{
          height: 40,
          color: "white",
        }}
      />
      <div
        style={{
          paddingTop: 70,
        }}
      >
        <Container
          style={{
            width: "100%",
            height: "100vh",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundImage: `url("/404.svg")`,
          }}
        >
          <Breadcrumbs links={[{ name: "トップ", url: "/" }]} />
          <Box
            style={{ paddingTop: "40vh" }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Box>
              <h1 style={{ fontSize: "48px" }}>404 not found</h1>
            </Box>
            <Box>
              <p>お探しのページが見つかりません。</p>
            </Box>
            <Box>
              <p>
                一時的にアクセスできない状態にあるか、移動もしくは削除された可能性があります。
              </p>
            </Box>
          </Box>
        </Container>
      </div>
    </>
  );
}
